import SuperRepository from '../superRepository'

export default new (class OfferPartnerCostHistoryRepository extends SuperRepository {
  baseUri() {
    return 'offer_partner_cost_history'
  }
})()